<template>
  <div class="content">
    <b-breadcrumb>
      <b-breadcrumb-item :to="{ path: '/dashboard/corredurias' }">Corredurías</b-breadcrumb-item>
      <b-breadcrumb-item active>Nueva correduría</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="container">
      <div v-if="loading">
        <div id="loader">
          <font-awesome-icon icon="spinner" spin />
        </div>
      </div>
    </div>

    <div class="wrapper wrapper-full-page section content">
      <div class="container">
        <card id="card">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(saveCorreduria)" @change="getAddressInMap(null)">
              <Form :correduria="correduria" @submit.prevent />
            </form>
          </ValidationObserver>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "@/views/staff/corredurias/Form.vue";
import Card from "src/components/Cards/Card.vue";
import { CorreduriasApi, RolesApi } from "@/api";
import { getGoogleMapUrl } from "@/utils/google-maps-utils";

export default {
  name: "EditCorreduria",

  components: {
    Form,
    Card,
  },

  data: () => ({
    id: 0,
    loading: false,
    roles: [],

    correduria: {
      id: 0,
      nombre: null,
      domicilios_id: 0,
      domicilio: {
        id: 0,
        calle: null,
        num_exterior: null,
        num_interior: null,
        colonia: null,
        delegacion_municipio: null,
        ciudad: null,
        entidad: null,
        pais: "México",
        codigo_postal: null,
        lat: 19.4320605, //default
        lng: -99.1335938, //default
      },
      staff: [],
      email: "",
      nombre_titular: "",
    },
  }),

  created() {
    this.getCorreduria();
  },

  methods: {
    async getCorreduria() {
      try {
        this.loading = true;

        const id = this.$route.params.id;
        this.id = id;

        if (!id) {
          return;
        }

        const { nombre, domicilio, domicilios_id, email, nombre_titular } = await CorreduriasApi.detail(id);

        this.correduria.nombre = nombre;
        this.correduria.id = id;
        this.correduria.domicilios_id = domicilios_id;
        this.correduria.domicilio.id = domicilio.id;
        this.correduria.domicilio.calle = domicilio.calle;
        this.correduria.domicilio.num_exterior = domicilio.num_exterior;
        this.correduria.domicilio.num_interior = domicilio.num_interior;
        this.correduria.domicilio.colonia = domicilio.colonia;
        this.correduria.domicilio.delegacion_municipio = domicilio.delegacion_municipio;
        this.correduria.domicilio.ciudad = domicilio.ciudad;
        this.correduria.domicilio.entidad = domicilio.entidad;
        this.correduria.domicilio.pais = domicilio.pais;
        this.correduria.domicilio.codigo_postal = domicilio.codigo_postal;
        this.correduria.domicilio.lat = domicilio.lat;
        this.correduria.domicilio.lng = domicilio.lng;
        this.correduria.email = email;
        this.correduria.nombre_titular = nombre_titular;

        await this.getStaff(id);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async getStaff(corredurias_id) {
      try {
        this.loading = true;

        const {
          odata_page: page,
          odata_total: total,
          odata_perpage: perPage,
          value,
        } = await StaffApi.list({
          page: 0,
          registersPerPage: 0,
          corredurias_id: corredurias_id,
        });

        await this.getRoles();

        for (let i = 0; i < value.length; i++) {
          var role_id = value[i].roles_id;
          var obj = this.roles.find((o) => o.id === role_id);
          value[i].rol = obj.rol;
        }
        this.correduria.staff = value;
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },

    async getRoles() {
      try {
        const { value } = await RolesApi.list({
          page: 0,
          registersPerPage: 0,
        });
        this.roles = value;
      } catch (error) {
        // this.$swal({
      }
    },

    async getAddressInMap() {
      const address = `${this.correduria.domicilio.calle},
                      ${this.correduria.domicilio.num_exterior},
                      ${this.correduria.domicilio.colonia},
                      ${this.correduria.domicilio.delegacion_municipio},
                      ${this.correduria.domicilio.codigo_postal},
                      ${this.correduria.domicilio.ciudad},
                      ${this.correduria.domicilio.entidad}
                      `;

      const mapUrl = await getGoogleMapUrl(address);
      this.correduria.domicilio.lat = mapUrl.lat;
      this.correduria.domicilio.lng = mapUrl.lng;
    },

    async saveCorreduria() {
      this.loading = true;
      // console.log(this.correduria.id);
      if (!this.correduria.id) {
        await this.newCorreduria();
      } else {
        await this.editCorreduria();
      }
      this.loading = false;
    },

    async editCorreduria() {
      const data = {
        nombre: this.correduria.nombre,
        domicilios_id: this.correduria.domicilios_id,
        domicilio: this.correduria.domicilio,
        staff: this.correduria.staff,
        activo: 1,
        email: this.correduria.email,
        nombre_titular: this.correduria.nombre_titular,
      };
      try {
        await CorreduriasApi.edit(this.id, data);
        this.$toast.success("Correduría actualizada", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
        this.loading = false;
      } catch (error) {
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      }
    },

    async newCorreduria() {
      try {
        const { id, domicilio } = await CorreduriasApi.create({
          nombre: this.correduria.nombre,
          // domicilios_id: this.correduria.domicilios_id,
          domicilio: this.correduria.domicilio,
          // staff: this.correduria.staff
          email: this.correduria.email,
          nombre_titular: this.correduria.nombre_titular,
        });
        this.id = id;
        this.correduria.id = id;
        this.correduria.domicilios_id = domicilio.id;
        this.correduria.domicilio.id = domicilio.id;
        this.$toast.success("Correduría creada", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      }
    },
  },
};
</script>

<style scoped>
#card {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: #ea640b;
  font-size: 13px;
}
</style>
